import { useState } from "react";
import axios from "axios";

const initialQuoteForm = {
  quoted_price: "",
  quote_notes: "",
};

export default function useAdminQuotes({ apiBaseUrl, fetchOrders, getErrorMessage, refreshStats, setLoading }) {
  const [showQuoteForm, setShowQuoteForm] = useState(false);
  const [selectedOrderForQuote, setSelectedOrderForQuote] = useState(null);
  const [quoteForm, setQuoteForm] = useState(initialQuoteForm);

  const openQuoteForm = (order) => {
    setSelectedOrderForQuote(order);
    setShowQuoteForm(true);
  };

  const closeQuoteForm = () => {
    setShowQuoteForm(false);
    setSelectedOrderForQuote(null);
  };

  const handleCreateQuote = async (event) => {
    event.preventDefault();
    if (!selectedOrderForQuote) return;

    setLoading(true);
    try {
      await axios.post(`${apiBaseUrl}/admin/quotes`, {
        order_id: selectedOrderForQuote.id,
        quoted_price: parseFloat(quoteForm.quoted_price),
        quote_notes: quoteForm.quote_notes,
      });
      let paymentMessage = "";
      if (selectedOrderForQuote.sales_channel === "retail_public") {
        try {
          const confirmResponse = await axios.post(`${apiBaseUrl}/admin/public-booking/${selectedOrderForQuote.id}/confirm`);
          const paymentUrl = confirmResponse.data?.payment_url;
          paymentMessage = paymentUrl
            ? `\n散客付款链接已生成并已发送给客户。\n${paymentUrl}`
            : "\n报价已保存，但付款链接暂未自动生成。请在订单卡片点击“确认并生成付款链接”重试。";
        } catch (confirmError) {
          paymentMessage = `\n报价已保存，但付款链接生成失败：${getErrorMessage(confirmError, "请在订单卡片点击“确认并生成付款链接”重试")}`;
        }
      }
      alert(`报价成功！${paymentMessage}`);
      closeQuoteForm();
      setQuoteForm(initialQuoteForm);
      fetchOrders();
      refreshStats?.();
    } catch (error) {
      alert(getErrorMessage(error, "报价失败"));
    } finally {
      setLoading(false);
    }
  };

  return {
    closeQuoteForm,
    handleCreateQuote,
    openQuoteForm,
    quoteForm,
    selectedOrderForQuote,
    setQuoteForm,
    showQuoteForm,
  };
}
